/*
 * Copyright(c) 1995 - 2020 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { NgModule } from '@angular/core';
import { GridColDirective } from './grid-col.directive';
import { GridRowDirective } from './grid-row.directive';

/**
 * Responsive Grid System adapts the user-screen responsively to the device width or to
 * the size of .box {@link src/assets/scss/layout/_boxes.scss:47}.
 * Under the hood it uses Twitter Bootstrap {@link https://getbootstrap.com/docs/4.0/layout/grid/}.
 *
 * Grid system made up of rows and columns. One row includes 12 columns the same width.
 *
 * Basic Usage:
 * <pre>
 *   Two columns 50%/50% for all breakpoints
 *   [---50%---|---50%---]
 *   <div commonRow>
 *       <div commonCol>
 *           Left column
 *       </div>
 *       <div commonCol>
 *           Right column
 *       </div>
 *   </div>
 *
 *   Three columns for medium and higher breakpoints
 *   [---50%---|-25%-|-25%-]
 *   <div commonRow>
 *       <div [commonCol]="6">
 *           Left column
 *       </div>
 *       <div [commonCol]="6" [commonColMd]="3">
 *           Center column
 *       </div>
 *       <div [commonCol]="6" [commonColMd]="3">
 *           Right column
 *       </div>
 *   </div>
 *
 *   The columns only for large and extra large breakpoints. Smaller breakpoints will be shown not as columns.
 *   [---50%---|-25%-|-25%-]
 *   <div commonRow>
 *       <div commonColLg>
 *           Left column
 *       </div>
 *       <div [commonColLg]="3">
 *           Center column
 *       </div>
 *       <div [commonColLg]="3">
 *           Right column
 *       </div>
 *   </div>
 * </pre>
 *
 * @see {@link GridColDirective} Column usage and options
 */
@NgModule({
    exports: [
        GridRowDirective,
        GridColDirective
    ],
    declarations: [
        GridRowDirective,
        GridColDirective
    ]
})
export class GridModule {
}
